import { render } from "./entry_data.vue?vue&type=template&id=16841c7f&scoped=true"
import script from "./entry_data.vue?vue&type=script&lang=js"
export * from "./entry_data.vue?vue&type=script&lang=js"

import "./entry_data.vue?vue&type=style&index=0&id=16841c7f&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16841c7f"]])

export default __exports__